import React, { FC } from 'react';
import { IIconProps } from 'app/components/svgs/Icon';

const Document: FC<IIconProps> = ({ size = '100%', height = size, width = size, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" preserveAspectRatio="xMidYMid meet" {...props}>
    <path
      fill="#000000"
      d="M8.354 0.354c-0.194-0.194-0.579-0.354-0.854-0.354h-6c-0.275 0-0.5
        0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225
        0.5-0.5v-9c0-0.275-0.159-0.659-0.354-0.854l-5.293-5.293zM13 15h-11v-14h5.487c0.046
        0.008 0.131 0.043 0.169 0.070l5.274 5.274c0.027 0.038 0.062 0.123 0.070 0.169v8.487zM13.5
        0h-3c-0.275 0-0.341 0.159-0.146 0.354l3.293 3.293c0.194 0.194 0.354 0.129
        0.354-0.146v-3c0-0.275-0.225-0.5-0.5-0.5z"
    />
  </svg>
);

export default Document;
